import { c as _c } from "react/compiler-runtime";
import { cn } from '@achra/ui/lib/utils';
import { Skeleton } from '@achra/ui/skeleton';
interface StepTriggerSkeletonProps {
  active?: boolean;
}
function StepTriggerSkeleton(t0) {
  const $ = _c(26);
  const {
    active
  } = t0;
  const t1 = active && "border-border";
  let t2;
  if ($[0] !== t1) {
    t2 = cn("border-accent flex h-8 overflow-hidden rounded-full border md:h-6.5 md:rounded-lg lg:h-10 2xl:h-12", t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = active && "bg-border";
  let t4;
  if ($[2] !== t3) {
    t4 = cn("bg-accent flex h-full w-8 items-center justify-center md:w-6 md:p-1 lg:w-8 lg:p-2 2xl:w-9.25 2xl:p-3", t3);
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const t5 = !active && "bg-border";
  let t6;
  if ($[4] !== t5) {
    t6 = cn("h-4.5 w-2.5 md:h-full", t5);
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== t6) {
    t7 = <Skeleton className={t6} />;
    $[6] = t6;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== t4 || $[9] !== t7) {
    t8 = <div className={t4}>{t7}</div>;
    $[8] = t4;
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  const t9 = active && "bg-border";
  let t10;
  if ($[11] !== t9) {
    t10 = cn("h-full md:w-4 lg:w-6", t9);
    $[11] = t9;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== t10) {
    t11 = <Skeleton className={t10} />;
    $[13] = t10;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  const t12 = active && "bg-border";
  let t13;
  if ($[15] !== t12) {
    t13 = cn("h-full w-20 2xl:w-30", t12);
    $[15] = t12;
    $[16] = t13;
  } else {
    t13 = $[16];
  }
  let t14;
  if ($[17] !== t13) {
    t14 = <Skeleton className={t13} />;
    $[17] = t13;
    $[18] = t14;
  } else {
    t14 = $[18];
  }
  let t15;
  if ($[19] !== t11 || $[20] !== t14) {
    t15 = <div className="hidden items-center gap-1 md:flex md:p-1 lg:gap-2 lg:p-2 2xl:p-3">{t11}{t14}</div>;
    $[19] = t11;
    $[20] = t14;
    $[21] = t15;
  } else {
    t15 = $[21];
  }
  let t16;
  if ($[22] !== t15 || $[23] !== t2 || $[24] !== t8) {
    t16 = <div className={t2}>{t8}{t15}</div>;
    $[22] = t15;
    $[23] = t2;
    $[24] = t8;
    $[25] = t16;
  } else {
    t16 = $[25];
  }
  return t16;
}
export { StepTriggerSkeleton };